import {resolveServiceUrl} from "~/build.ts";

const url = resolveServiceUrl('AGENT_CHAT_HOST');

export const CHAT_CONFIG = {
    /**
     * ADK server base URL, without trailing slash (e.g. https://chat.example.com)
     */
    BASE_URL: !url ? '' : url.origin,
    /**
     * Custom API routes base URL (download, feedback, sessions adapter)
     */
    API_URL: !url ? '' : new URL('/api/v1', url).href,
    /**
     * Default ADK app name — used as fallback when no agent is explicitly selected.
     */
    APP_NAME: 'atlas',
};

